import { AsepriteResource } from "@excaliburjs/plugin-aseprite";

export default class AssetLoader {
  static instance: any;
  cache: {};
  loader: any;

  constructor() {
    if (AssetLoader.instance) {
      return AssetLoader.instance;
    }
    this.cache = {};
    AssetLoader.instance = this;
  }

  // Method to load an image asset
  loadImage(url) {
    if (this.cache[url]) {
      return Promise.resolve(this.cache[url]);
    }

    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        this.cache[url] = image;
        resolve(image);
      };
      image.onerror = () => {
        reject(`Failed to load image: ${url}`);
      };
      image.src = url;
    });
  }

  // Method to load a JSON asset
  loadJSON(url) {
    if (this.cache[url]) {
      return Promise.resolve(this.cache[url]);
    }

    const resource = new AsepriteResource(url);
    return resource.load();
  }

  // Method to load an AsepriteResource using Excalibur's Loader
  loadAsepriteResource(path, slug, assetId) {
    const imageJsonPath = `${path}${slug}/image.json`;
    // Check cache first
    if (this.cache[assetId]) {
      return Promise.resolve(this.cache[assetId]);
    }

    return new Promise<void>((resolve, reject) => {
      // Load JSON and image simultaneously using Promise.all
      Promise.all([this.loadJSON(imageJsonPath)])
        .then(([resource]) => {
          // Store the loaded asset in cache with the given assetId
          this.cache[assetId] = { resource };

          // Create a SpriteSheet using Excalibur if needed (this can be added here)
          resolve();
        })
        .catch((error) => {
          reject(`Failed to load Aseprite resource: ${error}`);
        });
    });
  }

  // Method to load multiple AsepriteResources
  loadMultipleAsepriteResources(resources) {
    const loadPromises = resources.map(({ path, slug, assetId }) =>
      this.loadAsepriteResource(path, slug, assetId)
    );

    return Promise.all(loadPromises);
  }

  // Method to get a loaded asset by its unique identifier (assetId)
  getAssetById(assetId) {
    return this.cache[assetId];
  }

  // Method to get all loaded assets
  getAllAssets() {
    return this.cache;
  }
}
